import create from "zustand"
import { immer } from "zustand/middleware/immer"

const offset = .25;

const useStore = create(immer((set) => ({
  scrollPos: 0,
  sectionActive: 0,
  sections:7,
  updateScrollPos: (num) => set((state) => { 
    state.scrollPos = num
    const n = Number(num)
    // Damped scroll can overshoot below 0 when jumping back to the top of home.
    // A negative section indexes cursor/slide component maps with -1 and crashes.
    const section = Number.isFinite(n) ? (n < 1 ? Math.floor(n * 7) : 6) : 0
    state.sectionActive = Math.min(6, Math.max(0, section))
  //  state.sectionActive = (num <1) ? Math.floor(num * 7 - offset) : 6
  }),
})))

export default useStore